import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-off-white text-slate" data-id="element-0" data-mp="31cjjro54x0vk">
      <MetaPixel data-id="element-1" data-mp="2wj8dbo48im46" />
      <StickyHeader data-id="element-2" data-mp="2wip54z4dzc3c" />
      <main data-id="element-3" data-mp="2wi5mfg6wwjo9">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="28u5yeo0zj7dd" />
        <Hero data-id="element-5" data-mp="28suveqfd63nb" />
        <SocialProofBar data-id="element-6" data-mp="28sbbx5a2f776" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-off-white" aria-hidden="true" data-id="element-8" data-mp="23ut9zyugts8o" />} data-id="element-7" data-mp="23u9vks40xlze">
            <DeferredLanding data-id="element-9" data-mp="3ikqytzf4l45q" />
          </Suspense>}
      </main>
    </div>;
}